import { createApp } from 'vue';
import Participants from "../vue/CourseFlow/Participants.vue";
import Invoice from "../vue/CourseFlow/Invoice.vue";
import Confirmation from "../vue/CourseFlow/Confirmation.vue";
import {createRouter, createWebHashHistory} from 'vue-router'
import App from "../vue/CourseFlow/App.vue";
import StateGuard from "./StateGuard";
import state from "../vue/CourseFlow/state";
export default class CourseFlow {
    constructor(el) {
        const routes = [
            {
                path: '/',
                component: Participants,
                name: 'participants',
                meta: {
                    name: 'De cursist(en)',
                }
            },
            {
                path: '/factuur',
                component: Invoice,
                name: 'invoice',
                meta: {
                    name: 'Factuur',
                }
            },
            {
                path: '/bevestigen',
                component: Confirmation,
                name: 'confirmation',
                meta: {
                    name: 'Bevestigen',
                }
            },
        ]

        const router = createRouter({
            history: createWebHashHistory(),
            routes,
        })

        router.beforeEach((to, from) => {
            const stateGuard = new StateGuard(state);

            if (to.name === 'invoice') {
                if (stateGuard.getMaxStep() < 20) {
                    return { name: 'participants' }
                }
            }

            if (to.name === 'confirmation') {
                if (stateGuard.getMaxStep() < 30) {
                    return { name: 'invoice' }
                }
            }
        })

        this.el = el;
        this.vueComponent = createApp(App, JSON.parse(this.el.querySelector('script').textContent));
        this.vueComponent.use(router)
        this.vueComponent.mount(this.el);
    }
}
